import { MouseEvent, useCallback, useMemo } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Center,
  Image,
  Overlay,
  Paper,
  Text,
  useMantineTheme,
} from "@mantine/core";
import classes from "./MapLayerPickerCard.module.css";

type Props<T> = {
  label: string;
  value: T;
  imageSrc: string;
  onClick?: (value: T) => void;
  selected?: boolean;
};

export const MapLayerPickerCard = <T,>({
  label,
  value,
  imageSrc,
  onClick,
  selected = false,
}: Props<T>) => {
  const theme = useMantineTheme();

  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      onClick?.(value);
    },
    [onClick, value]
  );

  return useMemo(
    () => (
      <Paper
        onClick={handleClick}
        onContextMenu={(e: MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className={classes.card}
        mod={{ selected }}
        shadow="md"
      >
        <Box style={{ position: "relative" }}>
          <Image src={imageSrc} width={130} height={65} />
          {selected && (
            <Overlay opacity={1} color="#ffffff7d">
              <Center style={{ height: "100%" }}>
                <FontAwesomeIcon
                  icon={faCheck}
                  color={theme.colors[theme.primaryColor]?.[5]}
                  fontSize={46}
                />
              </Center>
            </Overlay>
          )}
        </Box>
        <Text
          c={selected ? theme.primaryColor : undefined}
          size="sm"
          px="xs"
          style={{
            whiteSpace: "nowrap",
            maxWidth: "100%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontWeight: selected ? "bold" : "normal",
            textAlign: "center",
          }}
        >
          {label}
        </Text>
      </Paper>
    ),
    [handleClick, imageSrc, label, selected, theme.colors, theme.primaryColor]
  );
};
